import { themeImages } from "@lib/images";

export const THEMES = ["environment", "human", "health", "animal"] as const;

export type ThemeCode = (typeof THEMES)[number];

const themeImageMap: { [name: string]: string } = {
  environment: themeImages.environment,
  human: themeImages.human,
  health: themeImages.health,
  animal: themeImages.animal,
};

export const selectThemeImage = (code: ThemeCode): string => {
  return themeImageMap[code];
};
